const SITECORE_IMAGE_PLACEHOLDER =
  '/sitecore/shell/Themes/Standard/Images/WebEdit/default_image';

/**
 * Make sure background is not shown in experience editor when it is the (injected) placeholder image
 */
export const isSitecorePlaceholderImage = (src?: string) => {
  return src?.includes(SITECORE_IMAGE_PLACEHOLDER);
};
